/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 15:20:32
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 14:58:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/OtherInformation/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Table from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { columns, storeInformationColumns } from '../config';
import css from '../css.module.less';
import AddInformation from './AddInformation';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const OtherInformation = ({
  information,
  storeInformation,
  setShowModal,
  setModalTitle,
  setModalContent,
  addInformation: addInformationFun,
  editInformation: editInformationFun,
  deleteInformation: deleteInformationFun,
  checkChange: checkChange,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const addInformation = () => {
    setShowModal(true);
    setModalTitle(
      getI18n('salesChannelInvoice.otherInformation.addInformation'),
    );
    setModalContent(
      <AddInformation
        onCancel={() => setShowModal(false)}
        onAdd={addInformationFun}
      />,
    );
  };
  const deleteInformation = (record) => {
    deleteInformationFun(record);
  };
  const editInformation = (record) => {
    setShowModal(true);
    setModalTitle(
      getI18n('salesChannelInvoice.otherInformation.editInformation'),
    );
    setModalContent(
      <AddInformation
        onCancel={() => setShowModal(false)}
        onAdd={editInformationFun}
        defaultData={record}
      />,
    );
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('salesChannelInvoice.otherInformation.informationTitle')}
      subtitle={getI18n(
        'salesChannelInvoice.otherInformation.informationSubTitle',
      )}>
      <Table
        id='storeInformation'
        rowKey='uuid'
        className={css.globalStoreTable}
        columns={storeInformationColumns(checkChange, disableEdit, { getI18n })}
        dataSource={storeInformation}
      />
      <Table
        id='information'
        rowKey='uuid'
        className={css.globalTable}
        columns={columns(deleteInformation, editInformation, disableEdit, {
          getI18n,
        })}
        dataSource={information}
      />
      <Button
        className={css.addInformation}
        type='primary'
        onClick={addInformation}
        disabled={disableEdit}>
        {getI18n('salesChannelInvoice.otherInformation.addInformation')}
      </Button>
    </SectionWrapper>
  );
};

export default OtherInformation;
